var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-about-banner",style:({
    backgroundColor: _vm.bgColor
  })},[_c('div',{staticClass:"new-center-container about-banner-center",style:({
      backgroundImage: ("url(" + _vm.bgImgae + ")")
    })},[_c('div',{staticClass:"box"},[_c('h3',[_vm._t("title")],2),_vm._v(" "),_c('h4',[_vm._t("subtitle")],2),_vm._v(" "),_c('p',{staticClass:"banner-btn"},[_c('RButton',{attrs:{"size":"middle","type":"primary"},on:{"click":_vm.btnClick}},[_vm._t("btn")],2)],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }